import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useInvoices = ({ paginated = false } = {}) => {
  const { user } = useAuth();
  
  const dynamicHook = useDynamicEntity({
    entityType: 'invoices',
    gqlEntityKey: 'invoices',
    queryName: 'GET_INVOICES',
    createMutation: 'CREATE_INVOICE',
    updateMutation: 'UPDATE_INVOICE',
    deleteMutation: 'DELETE_INVOICE',
    transformData: (invoice) => ({
      ...invoice,
      companyName: invoice.company?.name,
      company_name: invoice.company?.name,
      firm_name: invoice.contract?.firm?.firm_name,
      firm_short_name: invoice.contract?.firm?.firm_short_name,
      job_title: invoice.job?.job_title,
      pricing_process_name: invoice.pricing_process?.name,
      split_invoice: invoice.split_invoice,
      contractInfo: invoice.contract ? {
        firmName: invoice.contract.firm?.firm_name,
        firmShortName: invoice.contract.firm?.firm_short_name,
      } : null,
      jobInfo: invoice.job ? {
        title: invoice.job.job_title,
      } : null,
      pricingProcessInfo: invoice.pricing_process ? {
        name: invoice.pricing_process.name
      } : null,
    }),
    transformFormData: (formData) => {
      let firm_id = null;
      let firm_short_name = null;
      
      if (formData.firm_established === 'yes') {
        firm_id = formData.firmId;
        firm_short_name = null;
      } else {
        // firm_short_name seçimi aslında firm_id'yi temsil ediyor
        firm_id = formData.firm_short_name; // Bu artık firm_id
        firm_short_name = null;
      }
      
      
      return {
        company_id: formData.companyId || user?.companyId,
        firm_id: firm_id,
        firm_short_name: firm_short_name,
        firm_established: formData.firm_established === 'yes',
        contract_id: formData.contractId,
        job_id: formData.jobId,
        pricing_process_id: formData.pricingProcessId,
        invoice_name: formData.invoice_name,
        split_invoice: formData.split_invoice || false,
        custom_date_range: formData.custom_date_range || false,
        date_range_start: formData.date_range_start || null,
        date_range_end: formData.date_range_end || null,
        invoice_code_ids: formData.split_invoice ? (formData.invoice_code_ids || []) : null,
        payment_schedules: formData.payment_schedules || [],
        invoice_code_id: formData.invoice_code_id || null,
        total_unit_price: formData.total_unit_price || 0,
        change_pricing_method: formData.change_pricing_method || false,
        new_pricing_type: formData.change_pricing_method ? formData.new_pricing_type : null,
        new_start_date: formData.change_pricing_method ? formData.new_start_date : null,
      };
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { 
      company_id: { _eq: user?.companyId }
    },
    mutationPattern: 'invoices',
    createVariableName: 'invoice',
    updateVariableName: 'invoice',
    serverPagination: paginated,
    aggregateKey: paginated ? 'invoices_aggregate' : null,
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useInvoices };
